import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty';
import Divider from '@material-ui/core/Divider';
import { H4, Body1 } from 'components/Typography';
import styles from './styles';
import m from 'messages';

function Restrictions(props) {

    const { card, classes } = props;
    const hasRestrictions = isNotNullOrEmpty(card.restrictions);
    return (
        <div className={classes.fullWidth}>
            {hasRestrictions &&
                <div className={classes.container}>
                    <H4 paragraph>
                        {m.cards.restrictionsHeader}
                    </H4>
                    <div className={classes.body}>
                        {card.restrictions.map((r, index) =>
                            <React.Fragment key={index}>
                                <Body1 paragraph>
                                    {r.name}
                                </Body1>
                                <Divider />
                            </React.Fragment>
                        )}
                    </div>
                </div>
            }
        </div>
    );
}

Restrictions.propTypes = {
    card: PropTypes.object.isRequired
};

export default withStyles(styles)(Restrictions);